<template>
  <admin-layout :sectionTitle="sectionTitle">
    <!--<div class="page-header">
      <div class="row align-items-end">
        <div class="col-sm mb-2 mb-sm-0">
          <h1 class="page-header-title">Utenti</h1>
        </div>

        <div class="col-sm-auto">
          <a class="btn btn-primary" :href="route('users.create')"> Aggiungi utente </a>
        </div>
      </div>
    </div>-->

    <div class="card">
      <div class="card-header">
        <div class="row justify-content-between align-items-center flex-grow-1">
          <div class="col-sm-6 col-md-4 mb-3 mb-sm-0">
            <form>
              <!-- Search -->
              <div class="input-group input-group-merge input-group-flush">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <i class="tio-search"></i>
                  </div>
                </div>
                <input id="datatableSearch" type="search" class="form-control" placeholder="Cerca utente" aria-label="Cerca utente" />
              </div>
              <!-- End Search -->
            </form>
          </div>
          <div class="col-sm-auto">
            <a class="btn btn-primary" :href="route('users.create')"> Aggiungi utente </a>
          </div>
        </div>
      </div>

      <div class="table-responsive datatable-custom">
        <table id="datatable" class="table table-lg table-borderless table-thead-bordered table-nowrap table-align-middle card-table">
          <thead class="thead-light">
            <tr>
              <th>Nome</th>
              <th>Email</th>
              <th>Ruolo</th>
              <th>Creato il</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="user in pagination.data" :key="user.id">
              <td>
                <strong>{{ user.name }}</strong>
              </td>
              <td>{{ user.email }}</td>
              <td>{{ getRole(user) }}</td>
              <td>{{ formatDate(user.created_at) }}</td>
              <td class="actions">
                <a class="btn btn-sm p-0 btn-link" :href="route('users.edit', user.id)">
                  <i class="tio-visible-outlined"></i>
                </a>
                <a class="btn btn-sm p-0 btn-link" @click="onDelete(user)">
                  <i class="tio-delete"></i>
                </a>
                <a :href="route('impersonate.user', user.id)" class="btn btn-sm btn-link">
                  <i class="tio-sign-in"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="card-footer">
        <div class="row justify-content-center justify-content-sm-between align-items-sm-center">
          <div class="col-sm mb-2 mb-sm-0">
            <div class="d-flex justify-content-center justify-content-sm-start align-items-center">
              <span class="text-secondary">{{ pagination.current_page * pagination.data.length }} di {{ pagination.total }} utenti</span>
            </div>
          </div>

          <div v-if="pagination.per_page < pagination.total" class="col-sm-auto">
            <div class="d-flex justify-content-center justify-content-sm-end">
              <!-- Pagination -->
              <pagination :pagination="pagination" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import Pagination from "@/Layouts/Partials/Pagination";
import { DateTime } from "luxon";

export default {
  components: {
    AdminLayout,
    Pagination
  },

  props: ['sectionTitle'],

  data() {
    return {
      pagination: this.$page.props.users,
      form: this.$inertia.form(),
      role_labels: {
        Admin: "Amministratore",
        Appraiser: "Perito",
        Agent: "Agente",
        Manager: "Manager",
        Collaborator: "Collaboratore",
        Project_manager: "Project Manager",
        Call_center: "Call Center"
      }
    };
  },

  methods: {
    formatDate(date) {
      return DateTime.fromISO(date).toLocaleString(DateTime.DATE_FULL);
    },
    getRole(user) {
      if (user.roles.length == 0) return "";
      return user.roles.map(r => this.role_labels[r.name]).reduce((accumulator, currentValue) => `${accumulator}, ${currentValue}`);
    },
    onDelete(user) {
      const self = this;
      this.$confirm({
        message: `Eliminare l'utente "${user.name}"?`,
        button: {
          no: "No",
          yes: "Si"
        },
        callback: confirm => {
          if (confirm) {
            self.form.delete(route("users.destroy", user.id), {
              onSuccess: () => {
                self.pagination = self.$page.props.users;
              }
            });
          }
        }
      });
    }
  }
};
</script>
